import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import PrivacyPolicyCom from "../components/privacy-policy/PrivacyPolicyComp";
import SEO from "../components/shared/SEO";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";

export default function PrivacyPolicy() {
  return (
    <div>
      <SEO
        title="Privacy Policy | SoloConnect"
        description="Read the SoloConnect Privacy Policy to understand how we collect, use, and protect your personal information."
        keywords="privacy policy, data collection, user security, account safety, privacy rights"
      />
      <Newnabar />
      <div className="min-h-screen bg-white text-gray-800 px-4 md:px-20 py-10 pt-8 ">
        <PrivacyPolicyCom />
      </div>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
